import {headers} from "./constants";
import {DownloadButton} from "./components/download-button";
import {mapState} from "vuex";

export default {
  props: {
    activeFilters: Object,
    default: () => {}
  },
  components: {
    DownloadButton
  },
  data: () => ({
    windowWidth: window.innerWidth
  }),
  computed: {
    ...mapState('statistics', ['isLoadingSales', 'salesData']),
    headers() {
      return headers
    },
    mobileValues() {
      return [
        {
          name: "Pictures",
          value: `#${this.salesData.totals.pictures}`
        },
        {
          name: "Cash",
          value: `$${this.formatMoney(this.salesData.totals.cash)}`
        },
        {
          name: "Card",
          value: `$${this.formatMoney(this.salesData.totals.card)}`
        },
        {
          name: "Tax",
          value: `$${this.formatMoney(this.salesData.totals.tax)}`
        },
        {
          name: "Total",
          value: `$${this.formatMoney(this.salesData.totals.money)}`
        }
      ]
    }
  },
  methods: {
    formatMoney(value) {
      const number = Number(value) || 0;

      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(number);
    },
    onResize() {
      setTimeout(() => {
        this.windowWidth = window.innerWidth;
      })
    }
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
}